import React from "react";

const UpdatePropState = React.createContext();
UpdatePropState.displayName = "UpdatePropState";

export default UpdatePropState;
